/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedTrendsRouteImport } from './routes/_authenticated/trends'
import { Route as AuthenticatedTimelineRouteImport } from './routes/_authenticated/timeline'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedDataAccessRouteImport } from './routes/_authenticated/data-access'
import { Route as AuthenticatedCheckInRouteImport } from './routes/_authenticated/check-in'
import { Route as AuthenticatedAiCheckInRouteImport } from './routes/_authenticated/ai-check-in'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated/events.new'
import { Route as AuthenticatedEventsCompareRouteImport } from './routes/_authenticated/events.compare'
import { Route as AuthenticatedDevCarouselPreviewRouteImport } from './routes/_authenticated/dev/carousel-preview'
import { Route as AuthenticatedDailyDateRouteImport } from './routes/_authenticated/daily.$date'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTrendsRoute = AuthenticatedTrendsRouteImport.update({
  id: '/trends',
  path: '/trends',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTimelineRoute = AuthenticatedTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDataAccessRoute = AuthenticatedDataAccessRouteImport.update({
  id: '/data-access',
  path: '/data-access',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCheckInRoute = AuthenticatedCheckInRouteImport.update({
  id: '/check-in',
  path: '/check-in',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAiCheckInRoute = AuthenticatedAiCheckInRouteImport.update({
  id: '/ai-check-in',
  path: '/ai-check-in',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsCompareRoute =
  AuthenticatedEventsCompareRouteImport.update({
    id: '/events/compare',
    path: '/events/compare',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDevCarouselPreviewRoute =
  AuthenticatedDevCarouselPreviewRouteImport.update({
    id: '/dev/carousel-preview',
    path: '/dev/carousel-preview',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDailyDateRoute = AuthenticatedDailyDateRouteImport.update({
  id: '/daily/$date',
  path: '/daily/$date',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms': typeof TermsRoute
  '/ai-check-in': typeof AuthenticatedAiCheckInRoute
  '/check-in': typeof AuthenticatedCheckInRoute
  '/data-access': typeof AuthenticatedDataAccessRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/timeline': typeof AuthenticatedTimelineRoute
  '/trends': typeof AuthenticatedTrendsRoute
  '/daily/$date': typeof AuthenticatedDailyDateRoute
  '/dev/carousel-preview': typeof AuthenticatedDevCarouselPreviewRoute
  '/events/compare': typeof AuthenticatedEventsCompareRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms': typeof TermsRoute
  '/ai-check-in': typeof AuthenticatedAiCheckInRoute
  '/check-in': typeof AuthenticatedCheckInRoute
  '/data-access': typeof AuthenticatedDataAccessRoute
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/timeline': typeof AuthenticatedTimelineRoute
  '/trends': typeof AuthenticatedTrendsRoute
  '/daily/$date': typeof AuthenticatedDailyDateRoute
  '/dev/carousel-preview': typeof AuthenticatedDevCarouselPreviewRoute
  '/events/compare': typeof AuthenticatedEventsCompareRoute
  '/events/new': typeof AuthenticatedEventsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/terms': typeof TermsRoute
  '/_authenticated/ai-check-in': typeof AuthenticatedAiCheckInRoute
  '/_authenticated/check-in': typeof AuthenticatedCheckInRoute
  '/_authenticated/data-access': typeof AuthenticatedDataAccessRoute
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/timeline': typeof AuthenticatedTimelineRoute
  '/_authenticated/trends': typeof AuthenticatedTrendsRoute
  '/_authenticated/daily/$date': typeof AuthenticatedDailyDateRoute
  '/_authenticated/dev/carousel-preview': typeof AuthenticatedDevCarouselPreviewRoute
  '/_authenticated/events/compare': typeof AuthenticatedEventsCompareRoute
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/ai-check-in'
    | '/check-in'
    | '/data-access'
    | '/onboarding'
    | '/settings'
    | '/timeline'
    | '/trends'
    | '/daily/$date'
    | '/dev/carousel-preview'
    | '/events/compare'
    | '/events/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/ai-check-in'
    | '/check-in'
    | '/data-access'
    | '/onboarding'
    | '/settings'
    | '/timeline'
    | '/trends'
    | '/daily/$date'
    | '/dev/carousel-preview'
    | '/events/compare'
    | '/events/new'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/privacy'
    | '/register'
    | '/terms'
    | '/_authenticated/ai-check-in'
    | '/_authenticated/check-in'
    | '/_authenticated/data-access'
    | '/_authenticated/onboarding'
    | '/_authenticated/settings'
    | '/_authenticated/timeline'
    | '/_authenticated/trends'
    | '/_authenticated/daily/$date'
    | '/_authenticated/dev/carousel-preview'
    | '/_authenticated/events/compare'
    | '/_authenticated/events/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/trends': {
      id: '/_authenticated/trends'
      path: '/trends'
      fullPath: '/trends'
      preLoaderRoute: typeof AuthenticatedTrendsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/timeline': {
      id: '/_authenticated/timeline'
      path: '/timeline'
      fullPath: '/timeline'
      preLoaderRoute: typeof AuthenticatedTimelineRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/data-access': {
      id: '/_authenticated/data-access'
      path: '/data-access'
      fullPath: '/data-access'
      preLoaderRoute: typeof AuthenticatedDataAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/check-in': {
      id: '/_authenticated/check-in'
      path: '/check-in'
      fullPath: '/check-in'
      preLoaderRoute: typeof AuthenticatedCheckInRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ai-check-in': {
      id: '/_authenticated/ai-check-in'
      path: '/ai-check-in'
      fullPath: '/ai-check-in'
      preLoaderRoute: typeof AuthenticatedAiCheckInRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthenticatedEventsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events/compare': {
      id: '/_authenticated/events/compare'
      path: '/events/compare'
      fullPath: '/events/compare'
      preLoaderRoute: typeof AuthenticatedEventsCompareRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dev/carousel-preview': {
      id: '/_authenticated/dev/carousel-preview'
      path: '/dev/carousel-preview'
      fullPath: '/dev/carousel-preview'
      preLoaderRoute: typeof AuthenticatedDevCarouselPreviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/daily/$date': {
      id: '/_authenticated/daily/$date'
      path: '/daily/$date'
      fullPath: '/daily/$date'
      preLoaderRoute: typeof AuthenticatedDailyDateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAiCheckInRoute: typeof AuthenticatedAiCheckInRoute
  AuthenticatedCheckInRoute: typeof AuthenticatedCheckInRoute
  AuthenticatedDataAccessRoute: typeof AuthenticatedDataAccessRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedTimelineRoute: typeof AuthenticatedTimelineRoute
  AuthenticatedTrendsRoute: typeof AuthenticatedTrendsRoute
  AuthenticatedDailyDateRoute: typeof AuthenticatedDailyDateRoute
  AuthenticatedDevCarouselPreviewRoute: typeof AuthenticatedDevCarouselPreviewRoute
  AuthenticatedEventsCompareRoute: typeof AuthenticatedEventsCompareRoute
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAiCheckInRoute: AuthenticatedAiCheckInRoute,
  AuthenticatedCheckInRoute: AuthenticatedCheckInRoute,
  AuthenticatedDataAccessRoute: AuthenticatedDataAccessRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedTimelineRoute: AuthenticatedTimelineRoute,
  AuthenticatedTrendsRoute: AuthenticatedTrendsRoute,
  AuthenticatedDailyDateRoute: AuthenticatedDailyDateRoute,
  AuthenticatedDevCarouselPreviewRoute: AuthenticatedDevCarouselPreviewRoute,
  AuthenticatedEventsCompareRoute: AuthenticatedEventsCompareRoute,
  AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
